import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { freeCapacityCockpitPageQueryOptions } from "~/app/api/pageData/freeCapacityCockpitPageQuery";
import type { FreeCapacityCockpitPageInitialData } from "~/app/api/pageData/freeCapacityCockpitPageTypes";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { FreeCapacityCockpitPage } from "~/features/freeCapacityPush/FreeCapacityPushPage";

function FreeCapacityCockpitRoute() {
  const result = useLoaderData({
    from: "/freecapacitycockpit",
  }) as PageInitialData<FreeCapacityCockpitPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      <FreeCapacityCockpitPage downloadsEnabled={result.data?.downloadsEnabled ?? false} />
    </StorefrontShellFrame>
  );
}

export async function loadFreeCapacityCockpitPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(freeCapacityCockpitPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const freeCapacityCockpitRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/freecapacitycockpit",
  loader: async ({ context }) => loadFreeCapacityCockpitPageData(context),
  component: FreeCapacityCockpitRoute,
});
